import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from "preact";
import { getCurrentSchedule, getUserSession, setOrderer } from "../../api/Client";
import { Prefectures } from "../../const/prefecture";
export class PreserveOrdererFormComponent extends Component {
    constructor() {
        super();
        this.state = {
            name: "",
            firstName: "",
            lastName: "",
            nameKana: "",
            firstNameKana: "",
            lastNameKana: "",
            zipcode: "",
            prefectureCode: "",
            prefectureName: "",
            address1: "",
            address2: "",
            tel: "",
            email: "",
            birthday: "",
            gender: "",
            remarks: "",
        };
        this.handleInput = this.handleInput.bind(this);
    }
    render() {
        return (_jsxs("article", { children: [_jsxs("h4", Object.assign({ class: "content__title mt2" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u4E88\u7D04\u8005\u60C5\u5831\u5165\u529B"] }), void 0),
                _jsxs("div", Object.assign({ class: "form-container mb2" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsxs("label", Object.assign({ class: "label" }, { children: ["\u304A\u540D\u524D", _jsx("span", Object.assign({ class: "is-text-danger mx2" }, { children: "\u5FC5\u9808" }), void 0)] }), void 0),
                                _jsxs("div", Object.assign({ class: "field-body" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("p", Object.assign({ class: "control is-expanded" }, { children: _jsx("input", { type: "text", name: "firstName", class: this.fieldClass('firstName', 'input'), value: this.state.firstName ?? '', placeholder: "\u5C71\u7530", onInput: this.handleInput }, void 0) }), void 0), this.errorMessage('firstName')] }), void 0),
                                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("p", Object.assign({ class: "control is-expanded" }, { children: _jsx("input", { type: "text", name: "lastName", class: this.fieldClass('lastName', 'input'), value: this.state.lastName ?? '', placeholder: "\u592A\u90CE", onInput: this.handleInput }, void 0) }), void 0), this.errorMessage('lastName')] }), void 0)] }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u304A\u540D\u524D(\u30AB\u30CA)" }), void 0),
                                _jsxs("div", Object.assign({ class: "field-body" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("p", Object.assign({ class: "control is-expanded" }, { children: _jsx("input", { type: "text", name: "firstNameKana", class: this.fieldClass('firstNameKana', 'input'), value: this.state.firstNameKana ?? '', placeholder: "\u30E4\u30DE\u30C0", onInput: this.handleInput }, void 0) }), void 0), this.errorMessage('firstNameKana')] }), void 0),
                                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("p", Object.assign({ class: "control is-expanded" }, { children: _jsx("input", { type: "text", name: "lastNameKana", class: this.fieldClass('lastNameKana', 'input'), value: this.state.lastNameKana ?? '', placeholder: "\u30BF\u30ED\u30A6", onInput: this.handleInput }, void 0) }), void 0), this.errorMessage('lastNameKana')] }), void 0)] }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsxs("label", Object.assign({ class: "label" }, { children: ["\u96FB\u8A71\u756A\u53F7", _jsx("span", Object.assign({ class: "is-text-danger mx2" }, { children: "\u5FC5\u9808" }), void 0)] }), void 0),
                                _jsx("input", { type: "text", name: "tel", class: this.fieldClass('tel', 'input'), value: this.state.tel ?? '', placeholder: "0364096769", onInput: this.handleInput }, void 0), this.errorMessage('tel')] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsxs("label", Object.assign({ class: "label" }, { children: ["\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", _jsx("span", Object.assign({ class: "is-text-danger mx2" }, { children: "\u5FC5\u9808" }), void 0)] }), void 0),
                                _jsx("input", { type: "email", name: "email", class: this.fieldClass('email', 'input'), value: this.state.email ?? '', placeholder: "info@firstdeg.com", onInput: this.handleInput }, void 0), this.errorMessage('email')] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u90F5\u4FBF\u756A\u53F7" }), void 0),
                                _jsx("input", { type: "text", name: "zipcode", class: this.fieldClass('zipcode', 'input'), value: this.state.zipcode ?? '', placeholder: "141-0022", onInput: this.handleInput }, void 0), this.errorMessage('zipcode')] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u90FD\u9053\u5E9C\u770C" }), void 0),
                                _jsxs("select", Object.assign({ class: this.fieldClass('prefectureCode', 'input'), name: "prefectureCode", onChange: this.handleInput }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0),
                                        Object.entries(Prefectures).sort().map(m => {
                                            return (_jsx("option", Object.assign({ value: m[0], selected: this.state.prefectureCode === m[0] }, { children: m[1] }), void 0));
                                        })] }), void 0), this.errorMessage('prefectureCode')] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u5E02\u533A\u753A\u6751" }), void 0),
                                _jsx("input", { type: "text", name: "address1", class: this.fieldClass('address1', 'input'), value: this.state.address1 ?? '', placeholder: "\u54C1\u5DDD\u533A\u6771\u4E94\u53CD\u75301-22-6", onInput: this.handleInput }, void 0), this.errorMessage('address1')] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u756A\u5730\u4EE5\u4E0B" }), void 0),
                                _jsx("input", { type: "text", name: "address2", class: this.fieldClass('address2', 'input'), value: this.state.address2 ?? '', placeholder: "\u4E94\u53CD\u7530\u3055\u304F\u3089\u30D3\u30EB9F", onInput: this.handleInput }, void 0), this.errorMessage('address2')] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u5099\u8003" }), void 0),
                                _jsx("textarea", Object.assign({ class: this.fieldClass('remarks', 'textarea'), name: "remarks", onInput: this.handleInput }, { children: this.state.remarks }), void 0), this.errorMessage('remarks')] }), void 0)] }), void 0)] }, void 0));
    }
    componentDidMount() {
        getCurrentSchedule().then(response => {
            const sessionOrderer = response.data.orderer;
            if (sessionOrderer === null) {
                getUserSession().then(response => {
                    this.setState(response.data.userDetail);
                });
            }
            else {
                this.setState(response.data.orderer);
            }
        });
    }
    handleInput(e) {
        const elm = e.target;
        const value = elm.value;
        const name = elm.name;
        this.setState({ [name]: value });
        if (name === "firstName" || name === "lastName") {
            this.setState({
                name: `${this.state.firstName}${this.state.lastName}`
            });
        }
        if (name === "firstNameKana" || name === "lastNameKana") {
            this.setState({
                nameKana: `${this.state.firstNameKana}${this.state.lastNameKana}`
            });
        }
        if (name === "prefectureCode") {
            const prefecture = Object.entries(Prefectures).filter(p => p[0] === value);
            this.setState({
                prefectureName: prefecture.length > 0 ? prefecture[0][1] : ''
            });
        }
    }
    fieldClass(fieldName, base) {
        const validateError = this.hasError(fieldName) ? 'is-danger' : '';
        return `${base} ${validateError}`;
    }
    errorMessage(fieldName) {
        const errors = this.state.errors ?? {};
        const error = Object.entries(errors).filter(p => p[0] === fieldName);
        if (error.length > 0) {
            return error[0][1].map(m => (_jsx("p", Object.assign({ class: "help is-danger" }, { children: m }), void 0)));
        }
        return [];
    }
    hasError(fieldName) {
        const errors = this.state.errors ?? {};
        return Object.entries(errors).filter(p => p[0] === fieldName).length > 0;
    }
    hasErrors() {
        const errors = this.state.errors ?? {};
        return Object.entries(errors).length > 0;
    }
    setSession() {
        this.setState({ errors: null });
        return setOrderer(this.state).catch(e => {
            if (e.response.status === 400) {
                this.setState({
                    errors: e.response.data
                });
            }
        });
    }
}
